import axios from "axios";

const prices = {
    //producto precio
    get(params) {
        return axios.post(`${process.env.API1}/api/price/product`, params);
    },
}

export default prices



// WEBPACK FOOTER //
// ./src/services/prices.service.js